import React, { memo, useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import useAuthContext from '../providers/authProvider';
import { useTranslation } from "react-i18next";
import LanguageSwitcher from './LanguageSwitcher';
import { clubsCount } from '../services/users';

const NavBar = () => {
  const { t } = useTranslation();
  const { club, organizations, logout } = useAuthContext();
  const location = useLocation();
  const dropdownRef = useRef(null);
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [clubs, setClubs] = useState([]);

  useEffect(() => {
    const getClubs = async () => {
      try {
        const res = await clubsCount();
        setClubs(res.clubs);
      } catch (error) {
        console.error("Failed to fetch clubs:", error);
      }
    };
  
    getClubs();
  }, []);

  const libraries = [
    { id: 1, label: t("common.actions"), to: '/club_admin/actions' },
    { id: 2, label: t("common.exercises"), to: '/club_admin/exercises' },
    { id: 3, label: t("common.variations"), to: '/club_admin/exercise_collections' },
    { id: 4, label: t("common.practice-templates"), to: '/club_admin/practice_templates' },
  ];

  const navClass = path => {
    return location.pathname.includes(path) ? 'sidebar-nav active sidebar-menuitem' : 'sidebar-nav sidebar-menuitem';
  };

  const NavLink = ({ to, children }) => (
    <Link className={navClass(to)} to={to}>
      {children}
    </Link>
  );

  const handleClickOutside = event => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);
  
  return (
    <div>
       <div className="top-bar">
        <div className="logo">
          <img src="/images/logo.png" alt="logo" />
          Supercoach
        </div>
        <div className="logout">
          {organizations !== 0 && 
            <div className="sidebar-menuitem sidebar-nav">
              <Link to="/club_admin/organization">{t("buttons.common.organization")}</Link>
            </div>
          }
          {clubs && (
            <div className="sidebar-menuitem sidebar-nav">
              <Link to="/club_admin/clubs">{t("common.switch-club")}</Link>
            </div>
           )}
          <div className="sidebar-menuitem sidebar-nav">
            <a onClick={logout} href=''>
              {t("common.signout")}
            </a>
          </div>
        </div>
      </div>
      <div id="sidebar-wrapper">
        <ClubInfo club={club} navClass={navClass} />
        <NavLink to="/club_admin/teams">{t("common.teams")}</NavLink>
        <NavLink to="/club_admin/users">{t("common.members")}</NavLink>
        <NavLink to="/club_admin/lessons">{t("common.lessons")}</NavLink>

        <div className="sidebar-menuitem sidebar-nav dropdown" ref={dropdownRef}>
          <div className="dropdown-toggle" onClick={() => setMenuOpen(!isMenuOpen)}>
            {t("common.libraries")} <i className={`caret ${isMenuOpen ? 'open' : ''}`}></i>
          </div>
          {isMenuOpen && (
            <div className="dropdown_menu">
              {libraries?.map(option => (
                <NavLink key={option.id} to={option.to} onClick={() => setMenuOpen(!isMenuOpen)}>
                  {option.label}
                </NavLink>
              ))}
            </div>
          )}
        </div>
        <NavLink to="/club_admin/subscriptions">{t("common.premiums")}</NavLink>

        <LanguageSwitcher />
      </div>
    </div>
  );
};

export default memo(NavBar);

export const ClubInfo = memo(({ club, navClass }) => {
  const { t } = useTranslation();
  if (!club) return null;

  return (
    <Link className={`${navClass('/club_admin/club')} sidebar-label`} to="/club_admin/club">
      <div className="club-header">
        <div className="club">{t("common.club")}</div>
          { club?.premiums?.map((premium) => <span key={premium?.title} className="premiums-circle" style={{ backgroundColor: '#' + premium?.color }}></span>)}
        </div>
      <h4>{club?.name}</h4>
    </Link>
  );
});